import {getPoints} from './helpers/star.js'
import star from './helpers/star.js'
import Symbol2d from '../2d.js'

function calculateRadius (center) {
  const rays = 5
  const count = rays * 2 // Total points (tips + valleys)
  const i = 8 // Index for one of the leftmost points

  // Calculate the angle for the point at index 8
  const angle = (2 * Math.PI) / count
  const theta = i * angle - (Math.PI / 2)

  // Solve for the radius that makes the x-coordinate of the point at index 8 equal to 0
  return -center / Math.cos(theta)
}

function findYIntersection (l1, l2) {
  const m = (l2[1][1] - l2[0][1]) / (l2[1][0] - l2[0][0])
  const b = l2[0][1] - m * l2[0][0]
  return m * l1[0][0] + b
}

export default class Star extends Symbol2d {

  handles = [{
    defaults: [.5, .76],
    constraints: (dimensions) => {
      const radius = calculateRadius(dimensions.center[0])
      return [
        .5, [radius / dimensions.height, 1]
      ]
    },
    cursor: 'ns-resize'
  }]

  path (dimensions, handles) {
    const { center, radius, tipRadius } = this.getDimensions(dimensions, handles)

    return star(5, center, radius, tipRadius)
  }

  getDimensions(dimensions, handles) {
    const radius = calculateRadius(dimensions.center[0])
    const bottom = dimensions.height - radius
    const tipRadius = Math.max(bottom - (dimensions.height - dimensions.height * handles[0][1]), 5)
    const center = [dimensions.center[0], radius]
    return { center, radius, tipRadius }
  }

  textContainer (dimensions, handles) {
    const { center, radius, tipRadius } = this.getDimensions(dimensions, handles)

    // Get the points of the star
    const points = getPoints(10, center, radius, tipRadius)

    const xBound = points.at(3)[0] < points.at(4)[0] ? points.at(3) : points.at(4)
    const width = (xBound[0] - dimensions.center[0]) * 2

    // To find the yMin, we need to find the x inttersects the line between points 1 and 2
    const l1 = [[xBound[0], xBound[1]] ,[xBound[0], 0]]
    const l2 = [points.at(1), points.at(2)]
    const yMin = Math.max(findYIntersection(l1, l2), points.at(1)[1])

    const yMax = points.at(5)[1] < points.at(6)[1] ? points.at(5)[1] : points.at(6)[1]
    const height = yMax - yMin

    return {
      center: [center[0], yMin + height / 2],
      width: width,
      height: height
    }
  }

}
